function getMobileOS() {
  const containsIPhone = navigator.userAgent.match(/iphone/i);
  const containsAndroid = navigator.userAgent.match(/android/i);

  if (containsIPhone && !containsAndroid) {
    return 'ios';
  }

  if (containsAndroid && !containsIPhone) {
    return 'android';
  }

  return 'unknown';
}

/**
 * Returns a set of environment related keywords. These are not used for targeting, but instead for reporting and debugging issues.
 */
function getEnvironmentKeywords(
  deviceType: 'desktop' | 'tablet' | 'phone'
): Record<string, string> {
  return {
    'se-generic-mobile-os': getMobileOS(),
    'se-generic-sitemode': deviceType.replace('phone', 'mobile'),
    'se-aftonbladet-navigation': 'spa',
    'se-generic-appmode': 'notinapp',
    'se-generic-screenheight': window.screen.height.toString(),
    'se-generic-screenwidth': window.screen.width.toString(),
    'se-generic-viewportheight': window.innerHeight.toString(),
    'se-generic-viewportwidth': window.innerWidth.toString(),
  };
}

export { getEnvironmentKeywords };
